module.exports = __webpack_public_path__ + "img/selected5-min.3592d6a6.png";